import { useIsMobile } from '@/hooks/use-mobile'
import { SignupTypeSelectionScreenDesktop } from './SignupTypeSelectionScreenDesktop'
import { SignupTypeSelectionScreenMobile } from './SignupTypeSelectionScreenMobile'

export type AccountType = 'individual' | 'institution'

interface SignupTypeSelectionScreenProps {
  onSelect: (accountType: AccountType) => void
}

export const SignupTypeSelectionScreen = ({ onSelect }: SignupTypeSelectionScreenProps) => {
  const isMobile = useIsMobile()

  if (isMobile) {
    return <SignupTypeSelectionScreenMobile onSelect={onSelect} />
  }

  return <SignupTypeSelectionScreenDesktop onSelect={onSelect} />
}
